import { render } from "./NavBar.vue?vue&type=template&id=3ce70d90&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3ce70d90"

export default script